import { Controller } from "@hotwired/stimulus";

export default class<ElementType extends Element> extends Controller<ElementType> {
    remove() {
        this.element.remove();
    }
}
